var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseFilled = function SvgPauseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.032 20c-.65 0-1.183-.584-1.183-1.298V5.298C5.85 4.584 6.382 4 7.032 4h1.901c.65 0 1.183.584 1.183 1.298v13.404c0 .714-.532 1.298-1.183 1.298h-1.9Zm6.852-14.702c0-.714.532-1.298 1.183-1.298h1.9c.651 0 1.183.584 1.183 1.298v13.404c0 .714-.532 1.298-1.182 1.298h-1.901c-.65 0-1.183-.584-1.183-1.298V5.298Z",
    fill: "currentColor"
  })));
};
export default SvgPauseFilled;